module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTAiIGhlaWdodD0iOCIgdmlld0JveD0iMCAwIDEwIDgiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+DQo8cGF0aCBkPSJNNS4xMzM5NyAxLjVDNS41MTg4NyAwLjgzMzMzMyA2LjQ4MTEzIDAuODMzMzMzIDYuODY2MDMgMS41TDEwLjMzMDEgNy41QzEwLjcxNSA4LjE2NjY3IDEwLjIzMzkgOSA5LjQ2NDEgOUgyLjUzNTlDMS43NjYxIDkgMS4yODQ5NyA4LjE2NjY3IDEuNjY5ODcgNy41TDUuMTMzOTcgMS41WiIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoLTEgLTEpIiBmaWxsPSIjMjE5ODQ4Ii8+DQo8L3N2Zz4NCg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icons/price-up-small.svg
// module id = g7L3
// module chunks = 12